import PopoverMenu, { PopoverOption } from 'components/PopoverMenu'
import { buildTranslate } from 'locales'
import React from 'react'

const t = buildTranslate('live_updates.actions_menu')

export interface ActionsMenuItem {
  key: string
  label: string
  onClick: () => void
}

export interface ActionsMenuProps {
  items: ActionsMenuItem[]
}

// Every item is plain text: danger styling belongs to the confirmation a
// destructive item opens.
const ActionsMenu = ({ items }: ActionsMenuProps) => {
  if (items.length === 0) return null

  return (
    <PopoverMenu
      closeOnClick
      placement="bottomRight"
      testId="lu-actions-menu"
      ariaLabel={t('aria_label')}
    >
      {items.map(item => (
        <PopoverOption key={item.key} onClick={item.onClick}>
          {item.label}
        </PopoverOption>
      ))}
    </PopoverMenu>
  )
}

export default ActionsMenu
